import React from "react";
import { Tooltip, IconButton } from "@mzc-pdc/ui";
import { IconArrowBack, IconArrowForward, IconUp } from "@mzc-cloudplex/icons";
import i18n from "@lib/i18n";

const TreeViewNav = ({ treeViewHistory, onClickPrev, onClickNext, onClickUp }) => {
    return (
        <>
            <>
                <Tooltip title={i18n.t(`common::label::Previous`, `Previous`)}>
                    <IconButton
                        circled
                        size={"medium"}
                        disabled={!treeViewHistory || treeViewHistory?.index === 0}
                        onClick={(e) => {
                            e.stopPropagation();
                            onClickPrev();
                        }}
                    >
                        <IconArrowBack size={16} />
                    </IconButton>
                </Tooltip>
                <Tooltip title={i18n.t(`common::label::Next`, `Next`)}>
                    <IconButton
                        circled
                        size={"medium"}
                        disabled={!treeViewHistory || treeViewHistory?.index === treeViewHistory?.history?.length - 1}
                        onClick={(e) => {
                            e.stopPropagation();
                            onClickNext();
                        }}
                    >
                        <IconArrowForward size={16} />
                    </IconButton>
                </Tooltip>
                <Tooltip title={i18n.t(`common::label::Parent folder`, `Parent folder`)}>
                    <IconButton
                        circled
                        size={"medium"}
                        disabled={!treeViewHistory || !treeViewHistory?.selected?.parent}
                        onClick={(e) => {
                            e.stopPropagation();
                            onClickUp();
                        }}
                    >
                        <IconUp size={16} />
                    </IconButton>
                </Tooltip>
            </>
        </>
    );
};

export default TreeViewNav;
